import { saveResultList } from '../../../hooks/historyHook';
import { langList } from '../../../language';
export const SET_GAME_ID = 'SET_GAME_ID';
export const SET_QUESTION_FLAG = 'SET_QUESTION_FLAG';
export const SET_LOADING_STATE = 'SET_LOADING_STATE';
export const SET_TITLE = 'SET_TITLE';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_ACTIVITY_START_TIME = 'SET_ACTIVITY_START_TIME';
export const SET_ACTIVITY_END_TIME = 'SET_ACTIVITY_END_TIME';
export const SET_LOGIN_LIMIT = 'SET_LOGIN_LIMIT';
export const SET_SEND_TYPE = 'SET_SEND_TYPE';
export const SET_COVER = 'SET_COVER';
export const SET_FINISH_CONFIG = 'SET_FINISH_CONFIG';
export const SET_QUESTION_LIST = 'SET_QUESTION_LIST';
export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX';
export const SET_CURRENT_MATRIX_PAGE_INDEX = 'SET_CURRENT_MATRIX_PAGE_INDEX';
export const SET_TRANSLATE_DATA = 'SET_TRANSLATE_DATA';
export const PUSH_ANSWER_LIST = 'PUSH_ANSWER_LIST';
export const SET_CHOOSE_ANSWER = 'SET_CHOOSE_ANSWER';
export const SET_MATRIX_ANSWER = 'SET_MATRIX_ANSWER';
export const SET_NEW_QUESTION_LIST = 'SET_NEW_QUESTION_LIST';
export const SET_SURVEY_START_STATE = 'SET_SURVEY_START_STATE';
export const SET_SURVEY_END_STATE = 'SET_SURVEY_END_STATE';

export const UPDATE_QUESTION_RELATION_STATE = 'UPDATE_QUESTION_RELATION_STATE';
export const UPDATE_LANG_LIST = 'UPDATE_LANG_LIST';
export const UPDATE_ENTRY_QUESTION_TIME = 'UPDATE_ENTRY_QUESTION_TIME';
import { useTitle } from '@vueuse/core';

const documentTitle = useTitle();
export const mutations = {
  [SET_GAME_ID](state, gameId) {
    state.gameId = gameId;
    window['gameId'] = gameId;
  },
  [SET_QUESTION_FLAG](state, questionFlag) {
    state.questionFlag = questionFlag;
  },
  [SET_TITLE](state, title) {
    state.title = title;
    documentTitle.value = title;
  },
  [SET_ACTIVITY_START_TIME](state, time) {
    state.activityStartTime = time;
  },
  [SET_ACTIVITY_END_TIME](state, time) {
    state.activityEndTime = time;
  },
  [SET_LOGIN_LIMIT](state, loginLimit) {
    state.loginLimit = loginLimit;
  },
  [SET_SEND_TYPE](state, sendType) {
    state.sendType = sendType;
  },
  [SET_COVER](state, cover) {
    state.cover = cover;
  },
  [SET_CONFIG](state, config) {
    state.config = config;
  },
  [SET_FINISH_CONFIG](state, finishConfig) {
    state.finishConfig = finishConfig;
  },
  [SET_QUESTION_LIST](state, questionList) {
    state.questionList = questionList;
  },
  [SET_CURRENT_INDEX](state, currentIndex) {
    state.currentIndex = currentIndex;
  },
  [SET_CURRENT_MATRIX_PAGE_INDEX](state, currentMatrixPageIndex) {
    state.currentMatrixPageIndex = currentMatrixPageIndex;
  },
  [SET_TRANSLATE_DATA](state, data) {
    let hasData = (Array.isArray(data) && data.length > 0) || Object.keys(data).length > 0;
    hasData && (state.translate = data);
  },
  [PUSH_ANSWER_LIST](state, answer) {
    state.resultList.push(answer);
    saveResultList(state.resultList);
  },
  [SET_CHOOSE_ANSWER](state, answerArray) {
    state.chooseAnswer = answerArray;
  },
  [SET_MATRIX_ANSWER](state, matrixAnswer) {
    state.matrixAnswer = matrixAnswer;
  },
  [SET_LOADING_STATE](state, loadingState) {
    state.loadingState = loadingState;
  },
  [SET_SURVEY_START_STATE](state, canSurveyTimeStart) {
    state.canSurveyTimeStart = canSurveyTimeStart;
  },
  [SET_SURVEY_END_STATE](state, isSurveyEnd) {
    state.isSurveyEnd = isSurveyEnd;
  },
  [UPDATE_QUESTION_RELATION_STATE](state, [questionIndex, relationState]) {
    state.questionList[questionIndex].titleConfig.relationActive =
      relationState;
  },
  [UPDATE_LANG_LIST](state, list) {
    state.langList = list;
    langList.value = list;
  },
  [UPDATE_ENTRY_QUESTION_TIME](state, time) {
    state.enterQuestionTime = time;
  },
};
